/**
 * GAP-UC-43 — Per-user UI Preferences typed models.
 *
 * Typed strictly against the approved API contract:
 *   docs/artifacts/earchive-ui/GAP-UC-43-user-ui-preferences/specification/api-contract.md (§5/§6)
 *   docs/artifacts/earchive-ui/GAP-UC-43-user-ui-preferences/specification/openapi.yaml
 *
 * Endpoints (earchive-ntap-bl, interactive UI chain):
 *   GET  api/ntap/ui/preferences  -> UiPreferences        (getMyUiPreferences)
 *   PUT  api/ntap/ui/preferences  -> UiPreferences        (saveMyUiPreferences, body: UiPreferencesUpdate)
 * Per-user scoping is server-side from the session; there is deliberately NO userId (REQ-GAPUC43-019).
 */

/** api-contract §5 / openapi MenuState enum — default left-menu state. */
export type MenuState = 'COLLAPSED' | 'EXPANDED';

/**
 * Response DTO — the acting user's UI preferences (api-contract §5.1/§6).
 * Both fields are nullable; null = "no preference -> fall back to built-in default".
 * No id and no user reference are exposed (REQ-GAPUC43-019, REQ-GAPUC43-021).
 */
export interface UiPreferences {
  defaultMenuState: MenuState | null;
  /** Stores the stable menu item `name` (NOT label, NOT routerLink). Soft reference. */
  defaultLandingName: string | null;
}

/**
 * Request DTO — upsert the acting user's preferences (api-contract §5.2/§6).
 * Carries no id and no user reference (session-scoped). null clears a preference.
 */
export interface UiPreferencesUpdate {
  defaultMenuState: MenuState | null;
  defaultLandingName: string | null;
}

/** p-dropdown option: display `label`, store `name` (REQ-GAPUC43-007). */
export interface LandingOption {
  label: string;
  /** value === MenuItem.name (the stable persisted key). */
  value: string;
}

/** Built-in defaults applied when a preference is null or the store is unavailable (E3). */
export const DEFAULT_MENU_STATE: MenuState = 'EXPANDED';
